/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
import { createApp, defineAsyncComponent } from "vue";
//@ts-ignore
import { ZiggyVue } from "@ziggy/dist/vue";
//@ts-ignore
import { Ziggy } from "@ziggy/dist";
//@ts-ignore
import moment from "moment";
import vSelect from 'vue-select';
import store from 'store';
import Inputmask from "inputmask";
/**
 * Globally set locale to en-au for Luxon
 */
import { Settings } from 'luxon';
import { createPinia } from "pinia";
Settings.defaultLocale = 'en-au';
window.$ = window.jQuery = require('jquery');
window.axios = require('axios');
window.store = store;
window.moment = moment;
const app = createApp({});
// code split these pages so they are only sent to the browser when required
const DexAddNewCase = defineAsyncComponent(() => import("@components/Admin/Dex/Cases/AddNewCaseButton.vue"));
const ClientAppAccess = defineAsyncComponent(() => import("@components/Clients/ClientAppAccess/ClientAppAccess.vue"));
const TheEquipmentPage = defineAsyncComponent(() => import("@components/Data/Equipment/TheEquipmentPage.vue"));
const EquipmentUsageProfileBox = defineAsyncComponent(() => import("@components/Clients/Profile/EquipmentUsages/EquipmentUsageProfileBox.vue"));
const CarePlanProfileBox = defineAsyncComponent(() => import("@components/Clients/Profile/CarePlan/CarePlanProfileBox.vue"));
const ClientLinksProfileBox = defineAsyncComponent(() => import("@components/Clients/Profile/ClientLinks/ClientLinksProfileBox.vue"));
const ClientDocumentProfileBox = defineAsyncComponent(() => import("@components/Clients/Profile/ClientDocuments/ClientDocumentProfileBox.vue"));
const ClientInterestsProfileBox = defineAsyncComponent(() => import("@components/Clients/Profile/Interests/ClientInterestsProfileBox.vue"));
const SetPasswordPage = defineAsyncComponent(() => import("@components/Clients/signup/SetPasswordPage.vue"));
const LoginPage = defineAsyncComponent(() => import("@components/Authentication/Login/LoginPage.vue"));
const TwoFactorSetupPage = defineAsyncComponent(() => import("@components/Authentication/TwoFactorSetupPage.vue"));
const ResetPasswordPage = defineAsyncComponent(() => import("@components/Authentication/ResetPasswordPage.vue"));
const TheServicesTab = defineAsyncComponent(() => import("@components/Admin/ServiceOrganisations/Services/TheServicesTab.vue"));
const TheDocumentsPage = defineAsyncComponent(() => import("@components/Documents/TheDocumentsPage.vue"));
const EditDocument = defineAsyncComponent(() => import("@components/Documents/EditDocument.vue"));
const WorkerAppChats = defineAsyncComponent(() => import("@components/WorkerApp/Chats/WorkerAppChats.vue"));
const WorkerAppChatsModal = defineAsyncComponent(() => import("@components/WorkerApp/Chats/WorkerAppChatsModal.vue"));
const DocumentHistory = defineAsyncComponent(() => import("@components/Documents/DocumentHistory.vue"));
const WorkerAppSettings = defineAsyncComponent(() => import("@components/Settings/WorkerAppSettings.vue"));
const ClientAppSettings = defineAsyncComponent(() => import("@components/Settings/ClientAppSettings.vue"));
const TheTransNotesCategoriesPage = defineAsyncComponent(() => import("@components/Data/TransNotesCategories/TheTransNotesCategoriesPage.vue"));
const TheMdsLocationsPage = defineAsyncComponent(() => import("@components/Data/MdsLocations/TheMdsLocationsPage.vue"));
const ThePublicHolidaysPage = defineAsyncComponent(() => import("@components/Data/PublicHolidays/ThePublicHolidaysPage.vue"));
const TheLocalGovernmentAreasPage = defineAsyncComponent(() => import("@components/Data/LocalGovernmentAreas/TheLocalGovernmentAreasPage.vue"));
const ClientDocumentMiniList = defineAsyncComponent(() => import("@components/Clients/Documents/ClientDocumentMiniList.vue"));
const TheCustomConsentsPage = defineAsyncComponent(() => import("@components/Data/CustomConsents/TheCustomConsentsPage.vue"));
const TheCustomFieldsPage = defineAsyncComponent(() => import("@components/Data/CustomFields/TheCustomFieldsPage.vue"));
const TheWorkerCategoriesPage = defineAsyncComponent(() => import("@components/Data/WorkerCategories/TheWorkerCategoriesPage.vue"));
const TheCustomReportsPage = defineAsyncComponent(() => import("@components/Data/CustomReports/TheCustomReportsPage.vue"));
const IntegrationsDropboxIndexPage = defineAsyncComponent(() => import("@components/Integrations/Dropbox/IntegrationsDropboxIndexPage.vue"));
const AdminRunSheetSettingsPage = defineAsyncComponent(() => import("@components/Admin/RunSheetSettings/AdminRunSheetSettingsPage.vue"));
const DocumentImportIndexPage = defineAsyncComponent(() => import("@components/DocumentImport/DocumentImportIndexPage.vue"));
const DocumentImportPreviewPage = defineAsyncComponent(() => import("@components/DocumentImport/DocumentImportPreviewPage.vue"));
const TheHcpStatementsPage = defineAsyncComponent(() => import("@components/Models/HcpFundingPackageStatements/TheHcpStatementsPage.vue"));
const MessageCentreIndexPage = defineAsyncComponent(() => import("@components/MessageCentre/MessageCentreIndexPage.vue"));
const TheHcpFundingPackageAdjustmentReasonsPage = defineAsyncComponent(() => import("@components/Data/HcpFundingPackageAdjustmentReasons/TheHcpFundingPackageAdjustmentReasonsPage.vue"));
const AdminConnectedAppIndexPage = defineAsyncComponent(() => import("@components/Admin/ConnectedApp/AdminConnectedAppIndexPage.vue"));
const AdminConnectedAppAccessTokenIndexPage = defineAsyncComponent(() => import("@components/Admin/ConnectedApp/AccessToken/AdminConnectedAppAccessTokenIndexPage.vue"));
const TheNdisCataloguesPage = defineAsyncComponent(() => import("@components/Admin/NdisCatalogues/TheNdisCataloguesPage.vue"));
const TheServiceImportsPage = defineAsyncComponent(() => import("@components/Admin/ServiceImports/TheServiceImportsPage.vue"));
const TheAccountReportsPage = defineAsyncComponent(() => import("@components/Reports/AccountReports/TheAccountReportsPage.vue"));
app
    .use(ZiggyVue, Ziggy)
    .component('VueSelect', vSelect)
    .component("DexAddNewCase", DexAddNewCase)
    .component("ClientAppAccess", ClientAppAccess)
    .component("SetPasswordPage", SetPasswordPage)
    .component("EquipmentUsageProfileBox", EquipmentUsageProfileBox)
    .component("ClientInterestsProfileBox", ClientInterestsProfileBox)
    .component("CarePlanProfileBox", CarePlanProfileBox)
    .component("ClientLinksProfileBox", ClientLinksProfileBox)
    .component("ClientDocumentProfileBox", ClientDocumentProfileBox)
    .component("LoginPage", LoginPage)
    .component("TwoFactorSetupPage", TwoFactorSetupPage)
    .component("ResetPasswordPage", ResetPasswordPage)
    .component("TheServicesTab", TheServicesTab)
    .component("TheDocumentsPage", TheDocumentsPage)
    .component("TheEquipmentPage", TheEquipmentPage)
    .component("EditDocument", EditDocument)
    .component("WorkerAppChats", WorkerAppChats)
    .component("WorkerAppChatsModal", WorkerAppChatsModal)
    .component("DocumentHistory", DocumentHistory)
    .component("WorkerAppSettings", WorkerAppSettings)
    .component("ClientAppSettings", ClientAppSettings)
    .component("TheTransNotesCategoriesPage", TheTransNotesCategoriesPage)
    .component("TheDepartmentsPage", defineAsyncComponent(() => import("@components/Data/Departments/TheDepartmentsPage.vue")))
    .component("EditDepartmentPage", defineAsyncComponent(() => import("@components/Data/Departments/EditDepartmentPage.vue")))
    .component("TheMdsLocationsPage", TheMdsLocationsPage)
    .component("ThePublicHolidaysPage", ThePublicHolidaysPage)
    .component("TheLocalGovernmentAreasPage", TheLocalGovernmentAreasPage)
    .component("ClientDocumentMiniList", ClientDocumentMiniList)
    .component("TheCustomConsentsPage", TheCustomConsentsPage)
    .component("TheCustomFieldsPage", TheCustomFieldsPage)
    .component("TheWorkerCategoriesPage", TheWorkerCategoriesPage)
    .component("TheCustomReportsPage", TheCustomReportsPage)
    .component("IntegrationsDropboxIndexPage", IntegrationsDropboxIndexPage)
    .component("AdminRunSheetSettingsPage", AdminRunSheetSettingsPage)
    .component("DocumentImportIndexPage", DocumentImportIndexPage)
    .component("DocumentImportPreviewPage", DocumentImportPreviewPage)
    .component("MessageCentreIndexPage", MessageCentreIndexPage)
    .component("TheHcpFundingPackageStatementsPage", TheHcpStatementsPage)
    .component("TheHcpFundingPackageAdjustmentReasonsPage", TheHcpFundingPackageAdjustmentReasonsPage)
    .component("TheAccountReportsPage", TheAccountReportsPage)
    .component("AdminConnectedAppIndexPage", AdminConnectedAppIndexPage)
    .component("AdminConnectedAppAccessTokenIndexPage", AdminConnectedAppAccessTokenIndexPage)
    .component("TheNdisCataloguesPage", TheNdisCataloguesPage)
    .component("TheServiceImportsPage", TheServiceImportsPage)
    .component("TheCreateServiceImportLogPage", defineAsyncComponent(() => import("@components/Admin/ServiceImports/TheCreateServiceImportLogPage.vue")))
    .component("TheCurrentPortalUsersPage", defineAsyncComponent(() => import("@components/Data/CurrentUsers/PortalUsers/TheCurrentPortalUsersPage.vue")))
    // Allow a checkbox to be set to an "indeterminate" [-] state
    .directive("indeterminate", (el, binding) => el.indeterminate = Boolean(binding.value))
    .directive("mask", (el, binding) => Inputmask(binding.value).mask(el))
    .use(createPinia());
if (document.getElementById("clientProfileMain")) {
    app.mount("#clientProfileMain");
}
else if (document.getElementById('app')) {
    app.mount("#app");
}
